import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

// helpers
import { General } from 'icons/untitledui';

// styles
import * as Hint from 'pwa/styles/IosInstallHint.style';

interface InstallHintBannerProps {
  onDismiss: () => void;
}

export default function InstallHintBanner({
  onDismiss,
}: InstallHintBannerProps): JSX.Element {
  const { t } = useTranslation('pwa');

  return (
    <Hint.Container role="region" aria-label={t('installHint.title')}>
      <Hint.AppIcon src="/icons/apple-touch-icon.png" alt="" />
      <Hint.Content>
        <Hint.Title>{t('installHint.title')}</Hint.Title>
        <Hint.Instructions>
          <Trans
            i18nKey="installHint.instructions"
            t={t}
            components={[<General.Share01 key="0" size={16} />]}
          />
        </Hint.Instructions>
      </Hint.Content>
      <Hint.DismissButton
        type="button"
        $size="tiny"
        onClick={onDismiss}
        aria-label={t('installHint.dismiss')}
      >
        <General.XClose />
      </Hint.DismissButton>
    </Hint.Container>
  );
}
